import { useState, useRef } from "react";
import { Sparkles } from "lucide-react";

export function ImageCarousel({ images, apiUrl, large = false }) {
  const [current, setCurrent] = useState(0);
  const containerRef = useRef(null);

  if (!images || images.length === 0) {
    return (
      <div
        className={`w-full ${large ? "aspect-square" : "aspect-[4/3]"} bg-gradient-to-br from-coral-light via-secondary to-[#FEF3C7] flex flex-col items-center justify-center`}
      >
        <Sparkles className="w-8 h-8 text-coral/30 mb-2" />
        <span className="text-slate-400 text-sm font-body">
          Preview coming soon
        </span>
      </div>
    );
  }

  function handleScroll() {
    if (containerRef.current) {
      const idx = Math.round(
        containerRef.current.scrollLeft / containerRef.current.offsetWidth
      );
      setCurrent(idx);
    }
  }

  return (
    <div className="relative overflow-hidden">
      <div
        ref={containerRef}
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-hide"
        onScroll={handleScroll}
      >
        {images.map((img, i) => (
          <div key={img.id || i} className="min-w-full snap-center">
            <div className={`w-full ${large ? "aspect-square" : "aspect-[4/3]"} bg-[#F9F5EB] flex items-center justify-center`}>
              <img
                src={`${apiUrl}/api/images/${img.storage_path}`}
                alt=""
                className={`max-w-full max-h-full object-contain`}
                loading="lazy"
                draggable={false}
              />
            </div>
          </div>
        ))}
      </div>
      {images.length > 1 && (
        <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5 bg-black/20 backdrop-blur-sm rounded-full px-2 py-1">
          {images.map((_, i) => (
            <button
              key={`dot-${i}`}
              onClick={(e) => {
                e.stopPropagation();
                containerRef.current?.scrollTo({
                  left: i * containerRef.current.offsetWidth,
                  behavior: "smooth",
                });
              }}
              className={`h-2 rounded-full transition-all duration-300 ${
                i === current
                  ? "w-5 bg-slate-700 shadow-sm"
                  : "w-2 bg-slate-700/40"
              }`}
              aria-label={`Go to image ${i + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
